<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>भुगतान का परिचय</h2>
                </div>
                <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" alt=""></button>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="1">
                <div
                    style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                    <iframe class="i-frame" src="https://www.youtube.com/embed/Ee8A2oDqDRw?si=wcJ62-H4WxaERYp_"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>भुगतान का परिचय </h2>
                    <label for="" class="mt-2">पेआउट दस्तावेज़ीकरण में आपका स्वागत है, जो पेआउट प्रक्रियाओं को कुशलतापूर्वक समझने और लागू करने के लिए एक व्यापक मार्गदर्शिका है। इसमें मुआवजे, वेतन, पुरस्कार, वित्तीय लेनदेन के निपटान या संविदात्मक समझौतों की पूर्ति के रूप में धन का हस्तांतरण शामिल है।  </label>
                </div>
                <div class="col-md-12 mt-5  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">
                    <h2>भुगतान का उद्देश्य  </h2>
                    <label for="" class="mt-3">भुगतान का प्राथमिक उद्देश्य विभिन्न परिदृश्यों में धन या पुरस्कारों के उचित और समय पर वितरण की सुविधा प्रदान करना है। प्रमुख उद्देश्यों में शामिल हैं: </label>

                    <h4 class="mt-4"><b>मुआवज़ा </b></h4>
                    <label for="">जा पेआउट का उपयोग आमतौर पर व्यक्तियों या संस्थाओं को उत्पादों, सेवाओं या किए गए कार्यों के लिए मुआवजा देने के लिए किया जाता है। इसमें कर्मचारी वेतन, विक्रेता भुगतान, या वस्तुओं और सेवाओं के लिए भुगतान शामिल हो सकते हैं। </label>

                    <h4 class="mt-4"><b>पुरस्कार और प्रोत्साहन  </b></h4>
                    <label for="">व्यवसाय अक्सर विशिष्ट लक्ष्यों, मील के पत्थर या प्रदर्शन लक्ष्यों को प्राप्त करने के लिए व्यक्तियों या टीमों को पुरस्कार, बोनस या प्रोत्साहन वितरित करने के लिए भुगतान का उपयोग करते हैं। </label>

                    <h4 class="mt-4"><b>वित्तीय लेनदेन </b></h4>
                    <label for="">वित्तीय लेनदेन को निपटाने में भुगतान महत्वपूर्ण भूमिका निभाता है। इसमें ग्राहकों को धन वापस करना, खर्चों की प्रतिपूर्ति करना, या विभिन्न व्यावसायिक गतिविधियों के परिणामस्वरूप वित्तीय दायित्वों को पूरा करना शामिल हो सकता है। </label>

                    <h4 class="mt-4"><b>कमाई का वितरण </b></h4>
                    <label for="">निवेश के संदर्भ में, भुगतान निवेशकों या शेयरधारकों को कमाई या मुनाफे के वितरण का प्रतिनिधित्व करता है। यह लाभांश, ब्याज भुगतान या निवेश पर अन्य रिटर्न का रूप ले सकता है। </label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="4">
                    <h2>
                        भुगतान के तरीके बताए गए  
                    </h2>
                    <label for="">भुगतान विधियां वे अलग-अलग तरीके हैं जिनमें धन या पुरस्कार एक पार्टी से दूसरी पार्टी में वितरित किए जाते हैं। भुगतान पद्धति का चुनाव अक्सर लेन-देन की प्रकृति, शामिल पार्टियों की प्राथमिकताएं और उपलब्ध तकनीकी बुनियादी ढांचे जैसे कारकों पर निर्भर करता है। यहां सामान्य भुगतान विधियों के बारे में बताया गया है: </label>

                    <h4 class="mt-4"><b>बैंक हस्तांतरण </b></h4>
                    <label for="">इस पद्धति में एक बैंक खाते से दूसरे बैंक खाते में सीधे धनराशि स्थानांतरित करना शामिल है। यह भुगतान करने का व्यापक रूप से उपयोग किया जाने वाला और सुरक्षित तरीका है। .</label>

                    <h4 class="mt-4"><b>इलेक्ट्रॉनिक फंड ट्रांसफर (ईएफटी) </b></h4>
                    <label for="">बैंक हस्तांतरण के समान, ईएफटी एक डिजिटल तरीका है जो भौतिक जांच की आवश्यकता को समाप्त करते हुए, बैंक खातों के बीच इलेक्ट्रॉनिक रूप से धनराशि स्थानांतरित करता है। </label>

                    <h4 class="mt-4"><b>डिजिटल वॉलेट लेनदेन </b></h4>
                    <label for="">भुगतान डिजिटल वॉलेट में किया जा सकता है, जो धन संग्रहीत करने वाले आभासी प्लेटफॉर्म हैं। इसके बाद प्राप्तकर्ता विभिन्न लेनदेन के लिए डिजिटल वॉलेट बैलेंस का उपयोग कर सकते हैं।  </label>

                    <h4 class="mt-4"><b>पीयर-टू-पीयर (पी2पी) भुगतान ऐप्स </b></h4>
                    <label for="">मोबाइल एप्लिकेशन व्यक्तियों के बीच सीधे भुगतान की सुविधा प्रदान करते हैं, जो अक्सर बैंक खातों या क्रेडिट कार्ड से जुड़े होते हैं। </label>
                </div>

                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="5">
                    <h2>भुगतान के मामलों का उपयोग करें </h2>
                    <label for="">भुगतान बहुमुखी हैं और विभिन्न उद्योगों और परिदृश्यों में आवेदन पाते हैं। यहां सामान्य उपयोग के मामले दिए गए हैं जो भुगतान को नियोजित करने के विभिन्न तरीकों को दर्शाते हैं: </label>

                    <h4 class="mt-4"><b>कर्मचारी वेतन  </b></h4>
                    <label for="">नियोक्ता अपने कर्मचारियों को उनके काम के लिए मुआवजा देने के लिए भुगतान का उपयोग करते हैं </label>

                    <h4 class="mt-4"><b>ई-कॉमर्स लेनदेन </b></h4>
                    <label for="">ऑनलाइन खुदरा विक्रेता ग्राहकों को धन वापस करने, आपूर्तिकर्ताओं को भुगतान करने और लेनदेन का निपटान करने के लिए भुगतान का उपयोग करते हैं, जिससे ई-कॉमर्स पारिस्थितिकी तंत्र में धन का सुचारू प्रवाह सुनिश्चित होता है। </label>


                    <h4 class="mt-4"><b>विक्रेता भुगतान </b></h4>
                    <label for="">कंपनियां स्वस्थ व्यावसायिक संबंध बनाए रखते हुए, प्रदान की गई वस्तुओं और सेवाओं के लिए आपूर्तिकर्ताओं और विक्रेताओं को भुगतान करती हैं। </label>


                    <h4 class="mt-4"><b>फ्रीलांसर भुगतान  </b></h4>
                    <label for="">नियोक्ता प्रोजेक्ट कार्य के लिए फ्रीलांसरों को मुआवजा देने के लिए भुगतान का उपयोग करते हैं, जो अनुबंध-आधारित रोजगार को प्रबंधित करने का एक लचीला तरीका प्रदान करता है। </label>


                    <h4 class="mt-4"><b>शेयरधारकों को लाभांश </b></h4>
                    <label for="">कंपनियां शेयरधारकों को लाभांश के रूप में भुगतान जारी करती हैं, मुनाफे का एक हिस्सा उनके निवेश पर रिटर्न के रूप में वितरित करती हैं। </label>


                    <h4 class="mt-4"><b>प्रोत्साहन और पुरस्कार कार्यक्रम </b></h4>
                    <label for="">व्यवसाय वांछित व्यवहार या उपलब्धियों को प्रोत्साहित करने के लिए कर्मचारियों, ग्राहकों या भागीदारों के लिए प्रोत्साहन या पुरस्कार के रूप में भुगतान का उपयोग करते हैं। </label>


                    <h4 class="mt-4"><b>किराया और रियल एस्टेट भुगतान </b></h4>
                    <label for="">मकान मालिकों को किराए के भुगतान के रूप में किरायेदारों से भुगतान प्राप्त होता है, जिससे संपत्ति प्रबंधन की प्रक्रिया सरल हो जाती है। </label>


                    <h4 class="mt-4"><b>सरकारी सहायता और सामाजिक कार्यक्रम </b></h4>
                    <label for="">सरकारें सामाजिक कल्याण कार्यक्रमों के माध्यम से वित्तीय सहायता और समर्थन वितरित करने के लिए भुगतान का उपयोग करती हैं, जिससे पात्र व्यक्तियों को सहायता सुनिश्चित होती है। </label>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची   :
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> भुगतान को समझना   </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    भुगतान का उद्देश्य   </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">भुगतान के तरीके   </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">भुगतान के मामलों का उपयोग करें </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Hindi Payout 1.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    भुगतान अवलोकन</span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Payouts.pdf" download><img src="./assets/Download.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8    ">
                <a [routerLink]="['/create-profile']"><button class="btn btn-color" (click)="menues('Creating Profile')"
                    > <img src="./assets/Arrow 3.svg" alt=""> &nbsp;प्रोफ़ाइल बनाना
                    
                    &nbsp;</button></a> 
               </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/create-payout']">   <button class="btn btn-color" >पेआउट बनाए 
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>